<!-- @veltra/icons generated sha256:959ca34852e96fe2 gen:8 source:src/svg/normal/tips.svg -->
<script setup lang="ts">
defineOptions({ name: 'Tips' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M5.5 14.504c0 .268.22.496.496.496h4.008a.5.5 0 0 0 0-1H5.996a.5.5 0 0 0-.496.504M8 1a4.96 4.96 0 0 0-3.534 1.466A4.96 4.96 0 0 0 3 6c0 1.375.554 2.63 1.465 3.532.309.317.659.58 1.035.797V12a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1.671c.376-.216.726-.48 1.035-.797A4.96 4.96 0 0 0 13 6c0-2.766-2.234-5-5-5M5.176 3.171A3.96 3.96 0 0 1 8 2c2.214 0 4 1.786 4 4a3.96 3.96 0 0 1-1.171 2.824l-.008.008a3.8 3.8 0 0 1-1.045.75l-.276.139v1.787a.504.504 0 0 1-.512.492H7.012a.504.504 0 0 1-.512-.492V9.72l-.276-.138a3.8 3.8 0 0 1-1.045-.751l-.008-.008A3.96 3.96 0 0 1 4 6c0-1.104.445-2.106 1.171-2.824z"
    />
  </svg>
</template>
